import React, { useState, useEffect } from 'react';

interface ButtonProps {
  children: React.ReactNode; // 버튼 내부의 내용 (텍스트, 아이콘 등)
  onPress: () => void; // 버튼 클릭 이벤트 핸들러
  isDisabled?: boolean; // 버튼 비활성화 여부
  style?: React.CSSProperties; // React.CSSProperties 타입의 style 속성 추가
  icon?: React.ReactNode; // 아이콘을 React 노드 요소로 받는 prop
}

const RoundButton: React.FC<ButtonProps> = ({
  children,
  onPress,
  isDisabled = false,
  style,
  icon,
}) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const [down, setDown] = useState<boolean>(false);

  const handlePress = () => {
    if (!isDisabled) {
      onPress();
    }
  };

  return (
    <button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onMouseDown={() => !isDisabled && setDown(true)}
      onMouseUp={() => {
        !isDisabled && setDown(false);
        handlePress();
      }}
      onTouchStart={() => !isDisabled && setDown(true)} // 터치가 시작되면 (모바일 대응)
      onTouchEnd={() => setDown(false)} // 터치가 끝나면 (모바일 대응)
      style={{
        width: '100%',
        textAlign: 'center',
        padding: '15px 30px',
        fontSize: '14px',
        color: isDisabled ? '#999fbb' : 'white',
        border: 'none',
        borderRadius: '10px',
        outline: 'none',
        lineHeight: '1',
        // 클릭된 상태에 따라 배경색 변경
        backgroundColor: isDisabled
          ? '#414455'
          : down
          ? '#1D90F5'
          : hovered
          ? '#11548F'
          : '#1D90F5',
        opacity: isDisabled ? 0.7 : 1,
        cursor: isDisabled ? 'auto' : 'pointer',
        ...style,
      }}
      disabled={isDisabled}
    >
      {children}
      {icon && (
        <div
          style={{
            fontSize: '32px',
            lineHeight: '1px',
          }}
        >
          {icon}
        </div>
      )}
    </button>
  );
};

export default RoundButton;
